import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { GUIDE } from "@/components/newpartner/Topic";

const txt = (runs) => (runs || []).map((r) => r.t).join("");
const resText = (r) => r.label || r.text || r.seg?.t || "";

function index(data) {
  return data.stages.flatMap((s) => s.topics.map((t) => ({
    sid: s.id, nav: s.nav, tid: t.id, label: t.label,
    hay: [t.label, txt(t.body), txt(t.example), txt(t.action), ...t.resources.map(resText)].join(" \n ").toLowerCase(),
  })));
}

export default function GuideSearch({ data }) {
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  const all = useMemo(() => index(data), [data]);
  const term = q.trim().toLowerCase();
  const hits = term.length < 2 ? [] : all.filter((x) => x.hay.includes(term)).slice(0, 12);
  const go = (h) => { setQ(""); navigate(`${GUIDE}/${h.sid}#${h.tid}`); };
  return (
    <div className="relative" data-testid="np-search">
      <Search className="w-4 h-4 absolute left-3 top-3.5 text-slate-400" />
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search the New Partner Guide"
             aria-label="Search the New Partner Guide" className="pl-9 h-11 bg-white" data-testid="np-search-input" />
      {term.length >= 2 && (
        <div className="absolute z-20 mt-1 w-full rounded-xl border border-slate-200 bg-white shadow-lg max-h-80 overflow-y-auto" data-testid="np-search-results">
          {hits.length === 0 && <div className="px-4 py-3 text-sm text-slate-500" data-testid="np-search-empty">No matches in the New Partner Guide</div>}
          {hits.map((h) => (
            <button key={`${h.sid}-${h.tid}`} type="button" onClick={() => go(h)} data-testid={`np-search-hit-${h.sid}-${h.tid}`}
                    className="block w-full text-left px-4 py-2.5 hover:bg-[#C9A961]/10 focus:outline-none focus-visible:bg-[#C9A961]/10">
              <div className="text-sm font-medium text-[#0A1F44]">{h.label}</div>
              <div className="text-[11px] text-slate-500">{h.nav}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
